import React from 'react';
import { AlertTriangle, TrendingUp, Check, X } from 'lucide-react';
import { Button } from './Button';
import { Link } from './Router';

export const ProblemSolution: React.FC = () => {
  return (
    <section className="py-20 md:py-32 bg-gradient-to-b from-brand-gray to-white relative overflow-hidden">
      
      {/* Decorative blobs */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gray-100 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 -z-10"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="text-center mb-20">
           <span className="text-brand-orange font-black text-sm uppercase tracking-[0.3em] mb-4 block">Reality Check</span>
           <h2 className="text-4xl md:text-6xl font-black text-brand-dark uppercase tracking-tighter">
             Warum "Lecker" allein <br/>
             <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-brand-orange">nicht mehr reicht.</span>
           </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
           {/* Left: Problem & Agitation */}
           <div className="space-y-12">
              <div className="bg-white p-8 rounded-3xl shadow-xl border-l-8 border-red-500 relative overflow-hidden">
                 <div className="absolute top-0 right-0 p-4 opacity-10">
                    <X size={100} className="text-red-500" />
                 </div>
                 <div className="relative z-10">
                    <h3 className="text-2xl font-black text-brand-dark mb-4 flex items-center gap-3">
                       <AlertTriangle className="text-red-500" />
                       Das Problem
                    </h3>
                    <p className="text-gray-600 font-medium leading-relaxed mb-4">
                       Die Konkurrenz ist nur einen Swipe entfernt. Große Franchise-Ketten und hippe Pop-Ups graben dir das Wasser ab. Wer heute auf Social Media nicht stattfindet, existiert für Gen Z schlichtweg nicht.
                    </p>
                    <ul className="space-y-2">
                       <li className="flex items-center gap-2 text-red-500 font-bold text-sm"><X size={16} /> Website ist eine digitale Wüste</li>
                       <li className="flex items-center gap-2 text-red-500 font-bold text-sm"><X size={16} /> Content ohne Seele & Geschmack</li>
                       <li className="flex items-center gap-2 text-red-500 font-bold text-sm"><X size={16} /> Keine Sichtbarkeit bei Neukunden</li>
                    </ul>
                 </div>
              </div>

              <div className="bg-brand-dark p-8 rounded-3xl shadow-2xl relative overflow-hidden text-white">
                 <div className="absolute inset-0 bg-gradient-to-br from-gray-900 to-black z-0"></div>
                 <div className="absolute bottom-0 right-0 w-64 h-64 bg-brand-orange blur-[80px] opacity-20"></div>
                 
                 <div className="relative z-10">
                    <h3 className="text-2xl font-black mb-4 flex items-center gap-3 text-brand-orange">
                       <TrendingUp />
                       Die Konsequenz
                    </h3>
                    <p className="text-gray-300 font-medium leading-relaxed">
                       Du kämpfst jeden Monat um Umsatz, während dein Laden eigentlich voll sein müsste. Dein Personal ist frustriert, weil Trinkgeld fehlt. Du arbeitest IM Laden statt AM Business.
                    </p>
                 </div>
              </div>
           </div>

           {/* Right: Solution */}
           <div className="relative mt-8 lg:mt-0">
              <div className="absolute inset-0 bg-gradient-to-br from-brand-orange to-red-500 transform rotate-2 lg:rotate-3 rounded-[2.5rem] opacity-30 blur-lg"></div>
              <div className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl relative border-2 border-brand-orange/10">
                <h3 className="text-xs md:text-sm font-black text-brand-orange uppercase tracking-widest mb-4">Die Transformation</h3>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-dark mb-6 leading-tight">
                  Wir machen deine Brand <span className="text-brand-orange">zum Kult.</span>
                </h2>
                <p className="text-lg text-gray-600 mb-8 font-medium">
                  Schluss mit Experimenten. Wir installieren ein System, das deinen Laden füllt. Echter Content. Echter Hype. Echter Umsatz.
                </p>
                
                <ul className="space-y-4 mb-10">
                  {[
                    "High-End Food/Location Shoots vor Ort",
                    "Performance-Website für Reservierungen",
                    "Automatisierte Gästegewinnung",
                    "Marktführerschaft in deinem Kiez"
                  ].map((item, i) => (
                    <li key={i} className="flex items-center gap-4 font-bold text-brand-dark text-base md:text-lg">
                      <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-brand-orange to-red-500 flex items-center justify-center text-white flex-shrink-0 shadow-lg shadow-orange-500/30">
                        <Check size={16} strokeWidth={4} />
                      </div>
                      {item}
                    </li>
                  ))}
                </ul>

                <Link to="/leistungen">
                    <Button fullWidth variant="dark" className="text-lg py-4">
                        Wie wir das machen
                    </Button>
                </Link>
              </div>
           </div>
        </div>

      </div>
    </section>
  );
};